import React from 'react';
import { motion } from 'framer-motion';

const ChatPageWrapper = ({ children, className = "" }) => {
  const pageVariants = {
    initial: { 
      opacity: 0.85,
      y: 12
    },
    in: { 
      opacity: 1,
      y: 0
    },
    out: { 
      opacity: 0.85,
      y: -12
    }
  };

  const pageTransition = {
    type: "tween",
    ease: "easeOut",
    duration: 0.35
  };

  const containerVariants = {
    initial: { opacity: 0.9 },
    in: { 
      opacity: 1,
      transition: {
        staggerChildren: 0.08,
        delayChildren: 0.1
      }
    }
  };

  const childVariants = {
    initial: { 
      opacity: 0.8,
      y: 8
    },
    in: { 
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.3,
        ease: "easeOut"
      }
    }
  };

  return (
    <motion.div
      className={className}
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
      transition={pageTransition}
    >
      <motion.div
        variants={containerVariants}
        initial="initial"
        animate="in"
      >
        {React.Children.map(children, (child, index) => {
          if (React.isValidElement(child)) {
            return React.cloneElement(child, {
              variants: childVariants,
              custom: index
            });
          }
          return child;
        })}
      </motion.div>
    </motion.div>
  );
};

export default ChatPageWrapper;
